import React from "react";

function CCTVEquipment() {
    return (
        <div>
            <h2>CCTV Equipment & Monitoring Techniques</h2>
            <p>
                Understanding how to operate and maintain CCTV equipment is essential for effective surveillance. This module covers the types of systems used, control room setup, and best practices for monitoring and recording.
            </p>

            <h3>Types of CCTV Systems</h3>
            <ul>
                <li><strong>Analog Systems:</strong> Traditional wired cameras with DVRs</li>
                <li><strong>IP (Internet Protocol) Systems:</strong> Digital cameras connected via network</li>
                <li><strong>PTZ Cameras:</strong> Pan-Tilt-Zoom cameras for flexible coverage</li>
                <li><strong>Thermal/Infrared Cameras:</strong> Used in low-light or no-light conditions</li>
                <li><strong>Covert Cameras:</strong> Hidden or disguised for discreet monitoring</li>
            </ul>

            <h3>Control Room Setup</h3>
            <ul>
                <li>Monitors for live and recorded footage</li>
                <li>Recording devices (DVR/NVR)</li>
                <li>Communication systems (radios, intercoms)</li>
                <li>Access control integration (doors, gates)</li>
                <li>Secure environment with restricted access</li>
            </ul>

            <h3>Monitoring Techniques</h3>
            <ul>
                <li>Use camera presets and patrols for automated coverage</li>
                <li>Zoom in on suspicious activity using PTZ controls</li>
                <li>Monitor high-risk areas more frequently</li>
                <li>Log observations and incidents in real time</li>
                <li>Avoid “screen fatigue” by rotating tasks and staying alert</li>
            </ul>

            <h3>Recording & Playback</h3>
            <ul>
                <li>Ensure continuous recording is active and functioning</li>
                <li>Label and export footage when needed for evidence</li>
                <li>Follow data retention policies (e.g., 30 days)</li>
                <li>Secure backups and prevent unauthorized access</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> You notice a camera feed has gone black. What steps do you take to troubleshoot and report the issue?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – CCTV Equipment Training</a></li>
                <li><a href="https://www.ifsecglobal.com/" target="_blank" rel="noreferrer">IFSEC Global – Surveillance Technology News</a></li>
                <li><a href="https://www.gov.uk/government/publications/surveillance-camera-code-of-practice" target="_blank" rel="noreferrer">Surveillance Camera Code of Practice</a></li>
            </ul>
        </div>
    );
}

export default CCTVEquipment;
